module.exports = __webpack_public_path__ + "media/ตกอเวจีปอยเปตแสนล้านภพ.0a2d80d8.mp3";